module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Chapitre Quatre")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.00em",
      "text-transform": "uppercase"
    }
  }, [_vm._v("VERS")]), _vm._v(" vingt-et-une heures, Jonah se dirigea vers le bar près du bureau principal. Il avait pris un sandwich sur le chemin en retournant dans sa chambre et avait fait la sieste pendant une heure. Le soleil s’était déjà couché et les lampadaires scintillaient comme des étoiles dans la cour et illuminaient les allées qui sillonnaient les jardins à la française et menaient à la piscine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il prit le long chemin contournant les bâtiments et traversa la zone où les flamants roses se promenaient dans des étangs remplis de nénuphars et de carpes koïs colorées. Il s’arrêta au bord de l’eau et piocha dans sa poche les morceaux de pain qu’il avait gardés de son dîner.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu as encore faim, Larry ? demanda-t-il au plus grand des oiseaux qui s’était déplacé afin de vérifier le butin de la soirée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("L’oiseau s’approcha directement de lui et étira son long cou lorsque Jonah lui présenta la paume de sa main et lui offrit un peu de pain. Plusieurs oiseaux se joignirent bientôt à Larry afin de s’occuper rapidement des maigres restes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il y en aura plus demain, promit Jonah en reculant pour éviter le bec de Larry.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("L’oiseau se mit à crier et leva haut la tête comme s’il était offensé, puis il retourna vers les autres qui s’étaient retirés au centre de l’étang.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le bar n’était pas bondé. Plutôt typique pour un jour de semaine après le début et la fin de la grande ruée des Fêtes. À cette époque de l’année, la majorité des clients étaient plus âgés et préféraient passer leur soirée au piano-bar et au karaoké. Il jeta un coup d’œil dans la salle. Quelques couples en lune de miel à en juger par la façon dont ils se regardaient dans les yeux comme si personne d’autre n’existait, et quelques groupes de retraités, surtout des femmes, qui sirotaient des boissons à base de fruits avec des petits parasols et gloussaient comme des adolescentes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jonah avait toujours aimé étudier les clients. On pouvait apprendre beaucoup de choses sur l’humanité en observant les yeux des gens ou leur façon de bouger. Bien sûr, il était utile d’entendre des bribes de conversation, mais ce n’était pas aussi important.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Son regard se posa sur un homme assis seul au bar. Il avait des cheveux roux qui bouclaient sur la nuque et portait une chemise dont il avait relevé les manches jusqu’aux coudes, un short cargo et des tongs en cuir bien usées. Adam. L’homme qui lui avait demandé son chemin pour le centre de plongée. L’homme "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("très séduisant")]), _vm._v(" qui lui avait demandé son chemin pour le centre de plongée. L’homme qui le regardait maintenant avec intérêt.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("L’homme qui est client de l’hôtel")]), _vm._v(", se rappela-t-il.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Merde. Rien n’interdisait de boire avec des clients.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Est-ce que je peux me joindre à vous ? demanda-t-il à Adam.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam sourit quand il le reconnut, puis indiqua le tabouret de bar à sa gauche.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Comment pourrais-je refuser cela à quelqu’un qui est venu si gentiment à mon secours, dit-il ensuite.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Merci. Content de vous revoir, Adam.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jonah s’assit et fit signe à la barmaid. Sa cuisse frôla celle d’Adam et il s’éloigna instinctivement de la chaleur du contact.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Comme d’habitude, Dulcie, dit-il ensuite.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tout ce que vous voudrez, répondit-elle en souriant avant de sortir une bouteille de whisky single malt.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "a__Hlk527151208"
    }
  }, [_vm._v("— Quel traitement royal, constata Adam en riant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Monsieur James est un parfait gentleman, dit-elle en riant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Dulcie… lança Jonah, sur un ton de mise en garde amusée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle déposa leurs verres, fit un clin d’œil à Adam, puis partit s’occuper d’un autre client.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "a__Hlk527151519"
    }
  }, [_vm._v("— On dirait que vous avez une sacrée réputation")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Apparemment, confirma Jonah.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il attrapa son verre de whisky et le leva. Adam fit de même et lui offrit un sourire avant de boire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Dure journée au paradis ? demanda Jonah lorsque l’autre homme ne dit rien de plus.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam sourit avec nostalgie et fit tourbillonner le liquide dans son verre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Dure année. C’est pour ça que je suis là.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est pour cela que la majorité des gens se retrouvent ici, rétorqua Jonah.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Puis il attendit. Quand les gens avaient besoin de parler, ils finissaient toujours par le faire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam rit doucement et fit signe à Dulcie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Une autre bière.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Bien sûr, répondit-elle avant d’attirer l’attention de Jonah et presser ses lèvres ensemble pendant qu’elle tendait sa boisson à Adam.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "a__Hlk527212182"
    }
  }, [_vm._v("— Ce n’est rien d’important, dit ce dernier après avoir pris une longue gorgée de sa bouteille. Vous allez sans doute trouver ça ennuyeux à mourir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le léger tic d’un muscle sur la joue d’Adam disait à Jonah que le « rien » était énorme, du moins dans l’univers de l’autre homme.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Dites toujours.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam le regarda. Les pattes-d’oie autour de ses yeux trahissaient son envie de le faire. Il avait besoin de parler à quelqu’un. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Une personne qui le comprend, mais qui n’a rien à gagner dans cette histoire")]), _vm._v(". Jonah ignorait pourquoi il en savait autant sur les gens. Il savait, voilà tout. Observer les gens, les analyser, c’était aussi facile que de respirer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je dirige une entreprise familiale, dit Adam en fixant sa bouteille. Ordinateurs, composants, surtout. Je l’ai reprise lorsque mon père est décédé. Elle fonctionne plutôt bien.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous vous êtes retiré du commerce des composants.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je… oui, répondit Adam en fixant Jonah. Comment le savez-vous ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il n’y a pas d’argent à gagner avec les composants. Pas lorsqu’on peut acheter des machines sur mesure pour presque rien en ligne.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai suivi des cours de gestion ainsi que des cours de programmation et j’ai adoré ça. Je ne savais pas trop quoi faire après l’obtention de mon diplôme, alors j’ai fini par travailler pour mon père, expliqua-t-il. J’ai essayé de le convaincre de se diversifier. Je n’ai pas été très loin, mais il m’a laissé faire ce que je voulais. Les applications que j’ai créées ont plutôt bien fonctionné. J’ai même envisagé d’aller à l’université, mais lorsqu’il est mort…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("La vie ne vous emmène pas toujours là où vous voulez aller")]), _vm._v(". L’écho d’un souvenir remua dans les pensées de Jonah, puis disparut.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suis désolé, dit-il simplement.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne m’attendais à rien, répondit Adam en haussant les épaules. Mais j’avais quelques idées.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "a__Hlk527213738"
    }
  }, [_vm._v("— Quel genre d’idées ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Des trucs de geek, expliqua-t-il en faisant tourner sa bouteille avant de la prendre et de boire à nouveau. Des interfaces. Des programmes en arrière-plan. Ma sœur m’aide à diriger l’entreprise. Elle travaillait auparavant pour un cabinet d’avocats à Wall Street, spécialisé dans les brevets. Elle m’a convaincu de déposer les brevets de certains de mes programmes. Et, eh bien…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Quelqu’un les veut.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bien sûr que quelqu’un les voulait. Ce qui expliquait pourquoi Adam hésitait tant à se plaindre. Il avait sauvé à lui tout seul l’entreprise moribonde de son père, mais il se sentait coupable parce qu’il avait totalement changé l’orientation de l’entreprise. Jonah ressentait aussi une profonde fierté, derrière la culpabilité.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous avons débuté petit. J’ai vendu une licence à Yellow Zinger. Il s’agit d’une entreprise de logiciels de taille moyenne qui se lance dans les applications. J’ai engagé un développeur pour m’aider.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Une licence dont certains gros poissons ont entendu parler. Maintenant, ils veulent la compagnie.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Quelqu’un vous a offert beaucoup d’argent pour la société, mais vous ne voulez pas vendre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Comment avez-vous… ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est juste une supposition, répondit Jonah avec un sourire alors qu’il faisait signe à Dulcie pour avoir un autre verre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "a__Hlk527217029"
    }
  }, [_vm._v("— Travaillez-vous dans le domaine des technologies ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Non. Pourquoi cette question ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("C’était une question raisonnable, mais Jonah se sentit brusquement mal à l’aise, même un peu sur la défensive")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suis désolé, dit Adam, l’air vraiment contrit. Je ne voulais pas être indiscret. C’est juste que vous avez l’air de bien connaître ce secteur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il n’y a pas de mal, assura Jonah.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il se débarrassa du malaise qu’engendrait toujours le fait de parler du passé et se concentra une fois de plus sur l’autre homme.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Combien de temps restez-vous ? demanda celui-ci.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Son changement stratégique de conversation rappela encore une fois à Jonah qu’il avait réagi de façon excessive. Au moins, il n’avait pas totalement effrayé Adam.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— À l’hôtel ? Tant qu’ils voudront de moi, répondit-il en riant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Merde, s’exclama Adam en secouant la tête, les sourcils froncés. Désolé. Je ne suis pas si bouché, d’habitude. Vous travaillez ici, n’est-ce pas ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jonah hocha la tête.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cela explique pourquoi vous connaissez aussi bien le coin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pas besoin de vous excuser. Vous avez visiblement beaucoup de choses en tête.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Un silence gênant plana, mais Jonah l’ignora. Les silences étaient bons. Ils vous donnaient le temps d’analyser les faits. Un temps de réflexion.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je me suis juré de me détendre pendant ce voyage, dit Adam au bout d’un moment. Ça ne fait deux heures que je suis là et je suis déjà tout noué.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je connais la solution parfaite pour défaire ces nœuds.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Les joues d’Adam rougirent.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ce n’est pas ce que vous croyez, enchaîna Jonah rapidement, réalisant son erreur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il descendit de son tabouret et tendit la main à l’autre homme.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je veux juste vous montrer quelque chose.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— D’accord, accepta-t-il en prenant la main de Jonah.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ce dernier se dit que son frisson était dû à l’air frais du soir. Adam rougit, mais il se reprit une fois de plus. Trop tard bien sûr, mais l’effet était charmant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ils marchèrent en silence. Jonah les conduisit sur le chemin qui longeait la propriété de l’hôtel. Il s’arrêta près de la clôture qui délimitait la frontière entre l’hôtel et les buissons épais et les arbres au-delà.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’aurai des ennuis si quelqu’un découvre que je vous ai emmené ici, dit Jonah en plaisantant à moitié.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il s’en moquait, en vérité.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne dirais rien, assura Adam en lui pressant la main.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Face à ce geste chaleureux et engageant, Jonah dut lutter contre son désir d’en obtenir davantage.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sa poitrine palpitait d’excitation, comme le battement des feuilles de palmier dans la brise au-dessus de l’eau. Il pointa un doigt vers un endroit à environ trente centimètres de là, derrière un palmier. Une brèche dans la clôture juste assez grande pour s’y faufiler.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Par ici, indiqua-t-il.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il conduisit Adam à travers les arbres, se détendant à chaque pas sur le chemin familier. Les branches devenaient plus épaisses et l’odeur du sel plus forte.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "a__Hlk527274386"
    }
  }, [_vm._v("— Nous y sommes presque, dit Jonah en se penchant afin d’éviter plusieurs branches. Et… nous y voilà.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd33d43c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0008.vue
// module id = 78
// module chunks = 0